<template>
  <div>
    <input id="box2" type="checkbox" @change="check($event)" />
    <label for="box2"></label>
    <span style="line-height: 15px;"
      >I agree with the
      <!-- <router-link
        target="_blank"
        class="colorLink"
        :to="'/' + 'GeneralTerms/' + $i18n.locale"
        >General Terms</router-link
      > -->
      <a
        v-bind:href="pdfUrl ? pdfUrl : null"
        class="colorLink"
        v-bind:download="pdfUrl ? 'General Terms.pdf' : null"
        @click="openPDF"
        >General Terms</a
      >
      offered by the seller
      <a
        class="colorLink"
        target="_blank"
        :href="`${productData.clientWebsite}`"
        >{{ productData.clientName }}</a
      >. I also agree with the
      <a
        v-if="env === 'production'"
        class="colorLink"
        target="_blank"
        href="https://expar.si/general-terms/"
      >
        Expar Terms of Use & General Terms of Sale for Product Purchases.
      </a>
      <a
        v-else
        class="colorLink"
        target="_blank"
        href="https://demo.expar.si/splosni-pogoji-poslovan/"
      >
        Expar Terms of Use & General Terms of Sale for Product Purchases.
      </a>
      <!-- <router-link
        target="_blank"
        class="colorLink"
        :to="'/' + 'PrivacyPolicy/' + $i18n.locale"
        >Privacy Policy</router-link
      > -->
    </span>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    productData: null,
    errored: false,
    loading: true,
    pdfUrl: null,
    env: ''
  }),
  mounted() {
    this.env = process.env.NODE_ENV
    axios
      .get(
        this.isExperienceFooter
          ? `${process.env.VUE_APP_API_URL}/unitStore/unit/${this.$route.params.unitUUID}/experience/${this.$route.params.experienceUUID}`
          : `${process.env.VUE_APP_API_URL}/unitStore/unit/${this.$route.params.unitUUID}/product/${this.$route.params.productUUID}`
      )
      .then(response => {
        this.productData = response.data
        this.fetchPDF()
        localStorage.setItem('productData', JSON.stringify(this.productData))
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => (this.loading = false))
  },
  methods: {
    async fetchPDF() {
      try {
        if (this.productData.clientTC) {
          if (this.isPDFUrl(this.productData.clientTC)) {
            const response = await axios.get(
              `${process.env.VUE_APP_API_URL}/client/tc/download?url=${this.productData.clientTC}`,
              {
                responseType: 'blob'
              }
            )
            const pdfBlob = new Blob([response.data], {
              type: 'application/pdf'
            })
            this.pdfUrl = URL.createObjectURL(pdfBlob)
          }
        }
      } catch (error) {
        console.error('Error fetching PDF:', error)
      }
    },
    async openPDF() {
      try {
        if (!this.pdfUrl && this.productData.clientTC) {
          window.open(this.productData.clientTC, '_blank')
        }
      } catch (error) {
        console.error('Error downloading PDF:', error)
      }
    },
    isPDFUrl(url) {
      const filename = url.split('/').pop()
      return filename.toLowerCase().endsWith('.pdf')
    },
    check($event) {
      this.$emit('check-disclaimer', $event.target.checked)
    }
  },
  props: {
    // type: String
    isExperienceFooter: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="css" scoped>
@import url(//netdna.bootstrapcdn.com/font-awesome/3.2.1/css/font-awesome.css);

/*** basic styles ***/

body {
  margin: 30px;
}
h1 {
  font-size: 1.5em;
}
label {
  font-size: 24px;
}
span {
  font-size: 0.8em;
}
div {
  width: 90%;
  margin-left: 20px;
  display: table-cell;
  vertical-align: middle;
}

.colorLink {
  color: var(--bg) !important;
  text-decoration: underline;
}
.colorLink:hover {
  color: var(--primary) !important;
}
.colorLink:active {
  color: var(--primary) !important;
}

/*** custom checkboxes ***/

input[type='checkbox'] {
  display: none;
} /* to hide the checkbox itself */
input[type='checkbox'] + label:before {
  font-family: FontAwesome;
  display: inline-block;
}

input[type='checkbox'] + label:before {
  content: '\f096';
} /* unchecked icon */
input[type='checkbox'] + label:before {
  letter-spacing: 10px;
} /* space between checkbox and label */

input[type='checkbox']:checked + label:before {
  content: '\f046';
} /* checked icon */
input[type='checkbox']:checked + label:before {
  letter-spacing: 5px;
} /* allow space for check mark */
</style>
